import { AxiosResponse } from 'axios';
import { Request } from '../../../api';
import { Session } from '../../../utils';

export function getSessions(params?: {
    [key: string]: string;
}): Promise<AxiosResponse<{ data: Array<Session> }>> {
    return Request.get(`/workouts/sessions`, { params });
}
